var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 5C3.88071 5 5 3.88071 5 2.5C5 1.11929 3.88071 0 2.5 0C1.11929 0 0 1.11929 0 2.5C0 3.88071 1.11929 5 2.5 5ZM9 1C8.17157 1 7.5 1.67157 7.5 2.5C7.5 3.32843 8.17157 4 9 4H26C26.8284 4 27.5 3.32843 27.5 2.5C27.5 1.67157 26.8284 1 26 1H9ZM9 18C8.17157 18 7.5 18.6716 7.5 19.5C7.5 20.3284 8.17157 21 9 21H26C26.8284 21 27.5 20.3284 27.5 19.5C27.5 18.6716 26.8284 18 26 18H9ZM7.5 11C7.5 10.1716 8.17157 9.5 9 9.5H26C26.8284 9.5 27.5 10.1716 27.5 11C27.5 11.8284 26.8284 12.5 26 12.5H9C8.17157 12.5 7.5 11.8284 7.5 11ZM5 11C5 12.3807 3.88071 13.5 2.5 13.5C1.11929 13.5 0 12.3807 0 11C0 9.61929 1.11929 8.5 2.5 8.5C3.88071 8.5 5 9.61929 5 11ZM2.5 22C3.88071 22 5 20.8807 5 19.5C5 18.1193 3.88071 17 2.5 17C1.11929 17 0 18.1193 0 19.5C0 20.8807 1.11929 22 2.5 22Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedIcon);
export default __webpack_public_path__ + "static/media/feedIcon.907e50afe32af39f0e6df5a1868e5a38.svg";
export { ForwardRef as ReactComponent };